import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotificationList from './NotificationList';
import { getGlobalNotification } from '../../../../actions/appNotifications';

export function NotificationCard() {
  const dispatch = useDispatch();
  const tneList = useSelector((state) => state?.appNotifications?.notifications?.TnEnotification);
  const jobsList = useSelector((state) => state?.appNotifications?.notifications?.JobMatchNotification);

  useEffect(() => {
    dispatch(getGlobalNotification());
  }, []);

  return <NotificationList tneList={tneList} jobsList={jobsList} />;
}
